import { GradooTheme } from 'gradoo-theme/lib/types'
import { useState } from 'react'

import { FeatureFlagState } from 'shared/types/layoutcreator/graphql'
import Button from 'shared/ui/Button_2'
import Flex from 'shared/ui/Flex'
import Select from 'shared/ui/Select'
import Text from 'shared/ui/Text'

import ManageGroupsModal from '../ManageGroupsModal'
import { Separator } from './styles'

type FeatureFlagRowProps = {
  flagKey: string
  name: string
  description: string
  state: string
  limitedGroupIds: string[]
  onStateChange: (state: FeatureFlagState, index: number) => void
}

const FLAG_STATES_MAP: Record<FeatureFlagState, string> = {
  [FeatureFlagState.All]: 'All users',
  [FeatureFlagState.AdminOnly]: 'Admin Only',
  [FeatureFlagState.Limited]: 'Limited',
  [FeatureFlagState.Hidden]: 'Hidden'
}

const FeatureFlagRow = ({
  flagKey,
  name,
  description,
  state,
  limitedGroupIds,
  onStateChange
}: FeatureFlagRowProps) => {
  const [isManageGroupsModalOpen, setIsManageGroupsModalOpen] =
    useState(false)

  return (
    <Flex direction="column">
      <Flex
        direction="row"
        justifyContent="space-between"
        paddingTop={16}
        paddingBottom={16}
      >
        <Flex direction="column" rowGap={8}>
          <Text text={name} size={18} weight={600} />
          <Text
            text={description}
            size={14}
            weight={400}
            color={(theme: GradooTheme) => theme.color.base.c7}
          />
        </Flex>

        <Flex direction="column" rowGap={12}>
          <Flex alignItems="center" columnGap={8}>
            {state === FeatureFlagState.Limited && (
              <Button
                textId="Manage Groups"
                onPress={() => setIsManageGroupsModalOpen(true)}
                size="sm"
              />
            )}
            <Select
              width={136}
              activeIndex={Object.keys(FLAG_STATES_MAP).indexOf(
                state
              )}
              onChange={(_, index) => {
                onStateChange(
                  Object.keys(FLAG_STATES_MAP)[
                    index
                  ] as FeatureFlagState,
                  index
                )
              }}
              options={Object.values(FLAG_STATES_MAP)}
            />
          </Flex>

          {state === FeatureFlagState.Limited && (
            <Text
              text={`${limitedGroupIds.length} groups selected`}
            />
          )}
        </Flex>
      </Flex>
      <Separator />

      <ManageGroupsModal
        isOpen={isManageGroupsModalOpen}
        onClose={() => setIsManageGroupsModalOpen(false)}
        flagKey={flagKey}
        flagState={state as FeatureFlagState}
        initialGroupIds={limitedGroupIds}
      />
    </Flex>
  )
}

export default FeatureFlagRow
